module.exports = __webpack_public_path__ + "img/net.0bcb7c3f.png";